export default __webpack_public_path__ + "static/media/icon-em-row-arrow.625e3c6a.svg";